export default __webpack_public_path__ + "static/media/web-icon.ac4f46e6.svg";